import './post_view.js.coffee'
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.TwitterPostView extends Monitoring.Reports.Campaign.PostView
  className: "twitter-content"
  preview:  JST['backbone/templates/monitoring/reports/campaign/post_preview_twitter']
